import React from 'react';
import styled from 'styled-components';

import { H3 } from '../../../../../components';
import { ReactComponent as LogoMobile } from '../../../../../assets/images/logo-mobile.svg';

const NoAssetsReadOnlyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  height: 100vh;
`;

const StyledH3 = styled(H3)`
  margin-bottom: 8px;
  margin-top: 12px;
`;

const NoAssetsReadOnly = () => (
  <NoAssetsReadOnlyContainer>
    <LogoMobile />
    <StyledH3>No Assets</StyledH3>
    <H3 color='var(--content-subtitle)'>You can add assets to this space</H3>
    <H3 color='var(--content-subtitle)'>Once you have edit access</H3>
  </NoAssetsReadOnlyContainer>
);

export { NoAssetsReadOnly };
